<template>
  <a-modal
      :title="`${actType}主体`"
      centered
      :width="640"
      :mask-closable="false"
      :visible="showForm"
      :confirmLoading="loading"
      @cancel="close"
  >
    <a-form-model
      ref="form"
      :model="model"
      :rules="rules"
      :label-col="labelCol"
      :wrapper-col="wrapperCol"
      >
        <a-spin :spinning="loading">
          <a-form-model-item label="名称" prop="name">
            <a-input v-model="model.name" />
          </a-form-model-item>
        </a-spin>
      </a-form-model>

    <template slot="footer">
      <a-button @click="close" :disabled="loading">取消</a-button>
      <a-button type="primary" @click="submit" :disabled="loading">确定</a-button>
    </template>
  </a-modal>
</template>

<style lang="less" scoped>
@import 'Create';
</style>

<script>
import Create from './Create'
export default Create
</script>
